var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"switch-wrap",on:{"click":_setup.toggleSwitch}},[_c('div',{staticClass:"switch",class:{ active: _setup.active }},[_c('div',{staticClass:"switch-toggle",class:{ "ketch-translate-x-[14px]": _setup.active }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }